import { useState } from "react";
import { Check } from "lucide-react";
import { toast } from "sonner";
import { api, today, useSubmit } from "@/lib/api";
import { ErrorBox, Field, Modal } from "@/components/common";
import PatientPicker from "@/components/PatientPicker";

export const STATUSES = [{ value: "planned", label: "Planned" }, { value: "in_progress", label: "In progress" }, { value: "completed", label: "Completed" }, { value: "cancelled", label: "Cancelled" }];

export default function TreatmentForm({ patientId, onClose, onSaved }) {
  const [form, setForm] = useState({ patient_id: patientId || "", treatment: "", tooth: "", agreed_amount: "", status: "planned", date: today(), notes: "" });
  const { busy, error, run } = useSubmit();
  const set = (k) => (v) => setForm({ ...form, [k]: v });
  const save = () => run(async () => {
    const r = await api.post("/treatments", { ...form, agreed_amount: Number(form.agreed_amount) });
    toast.success("Treatment added to the ledger");
    onSaved(r.data);
  });
  return (
    <Modal eyebrow="TREATMENT LEDGER" title="Add treatment" onClose={onClose} onSubmit={save} testid="treatment-form">
      {!patientId && <PatientPicker value={form.patient_id} onChange={set("patient_id")} testid="treatment-patient-select" />}
      <Field label="Treatment" testid="treatment-name-input" required value={form.treatment} onChange={set("treatment")} placeholder="e.g. Root canal treatment" />
      <div className="form-two">
        <Field label="Tooth" testid="treatment-tooth-input" value={form.tooth} onChange={set("tooth")} placeholder="e.g. 36" />
        <Field label="Agreed amount (₹)" type="number" min="0" step="0.01" testid="treatment-amount-input" required value={form.agreed_amount} onChange={set("agreed_amount")} />
      </div>
      <div className="form-two">
        <Field label="Status" testid="treatment-status-select" value={form.status} onChange={set("status")} options={STATUSES} />
        <Field label="Date" type="date" testid="treatment-date-input" required value={form.date} onChange={set("date")} />
      </div>
      <Field label="Notes" textarea testid="treatment-notes-input" value={form.notes} onChange={set("notes")} rows={2} />
      <ErrorBox error={error} testid="treatment-form-error" />
      <button className="primary full" disabled={busy} data-testid="save-treatment-button"><Check size={17} /> {busy ? "Saving…" : "Save treatment"}</button>
    </Modal>
  );
}
